import(/* webpackMode: "eager" */ "/vercel/path0/app/stories/page.js");
